import React from 'react';

import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';
import UnknownMonitor from 'shared/ui/icons/UnknownMonitor';
import {PALETTE} from 'shared/config/model/palette';

interface IIncidentStatusProps {
    resolved: boolean;
    incompleteFail?: boolean;
    incompleteSuccess?: boolean;
}

const IncidentStatus: React.FC<IIncidentStatusProps> = ({
    resolved,
    incompleteFail,
    incompleteSuccess,
}) => {
    return (
        <div>
            {!resolved && incompleteFail && <UnknownMonitor color={PALETTE.error} />}
            {!resolved && !incompleteFail && <ProblemMonitor />}
            {resolved && incompleteSuccess && <UnknownMonitor color={PALETTE.success} />}
            {resolved && !incompleteSuccess && <SuccessfulMonitor />}
        </div>
    );
};

export default IncidentStatus;